var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"savings-tips"},[_c('h3',[_vm._v(_vm._s(_vm.savingsTip.heading))]),_c('p',[_vm._v(_vm._s(_vm.savingsTip.text))]),_c('p',[_c('router-link',{attrs:{"to":"/main/all-tips"}},[_vm._v("View all")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }